import { Link } from 'react-router-dom';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const DigitalServices = () => {
	return (
		<div className="min-h-screen" style={{ backgroundColor: '#e6e6b8' }}>
			<div className="top-0 z-10000 w-full px-0 py-3 sm:p-6">
				<Navbar />
			</div>
			<br />

			{/* Features */}
			<section style={{ paddingTop: '30px' }}>
				<div className="container mx-auto">
					<div className="text-center">
						{/* A hard width:400px was wider than a 360px phone and pushed the
						    whole page into horizontal scroll. Fluid up to the same 400px. */}
						<div
							className="inline-block w-full max-w-[400px] rounded-[8px] px-5 py-4 text-lg font-bold sm:px-10 sm:py-5 sm:text-[22px]"
							style={{ background: '#1b5e20', color: '#ffd600', boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}>
							رياضيات
							<br />
							سنة 3 ثانوي
							<br />
							شعبة آداب وفلسفة
						</div>
					</div>
					<br />

					<div className="text-center">
						<div
							className="mx-auto my-10 max-w-[600px] break-words rounded-[10px] p-6 text-xl font-bold sm:p-10 sm:text-[28px]"
							style={{ background: '#ffe600', color: '#1b5e20', lineHeight: '1.6', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}>
							ملخص
							<br />
							المتتالية الحسابية + المتتالية الهندسية
							<br />
							+<br />
							إتجاه تغير دالة
						</div>
					</div>

					<div className="text-center">
						<div className="mt-5 text-2xl font-bold sm:text-3xl" style={{ color: '#1b5e20', textShadow: '0 0 10px #ffd600' }}>
							✨ ب 3000 دج فقط ✨
						</div>
					</div>
					<br />

					{/* Same treatment as the lessons page: three fixed-padding buttons
					    do not fit one phone row, so stack them until there is room. */}
					<div className="mt-5 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
						<Link to="/register" className="w-full sm:w-auto">
							<button
								className="w-full cursor-pointer rounded-[8px] border-0 px-6 py-3 text-lg sm:w-auto sm:px-[35px] sm:py-[15px] sm:text-xl"
								style={{ background: '#1b5e20', color: 'rgb(236, 213, 7)' }}>
								شراء ملخص
							</button>
						</Link>

						<a href="https://wa.me/213XXXXXXXXX" target="_blank" className="w-full sm:w-auto">
							<button
								className="w-full cursor-pointer rounded-[8px] border-0 px-6 py-3 text-lg sm:w-auto sm:px-[35px] sm:py-[15px] sm:text-xl"
								style={{ background: '#25D366', color: 'rgb(236, 213, 7)' }}>
								واتساب
							</button>
						</a>

						<a href="https://www.facebook.com" target="_blank" className="w-full sm:w-auto">
							<button
								className="w-full cursor-pointer rounded-[8px] border-0 px-6 py-3 text-lg sm:w-auto sm:px-[35px] sm:py-[15px] sm:text-xl"
								style={{ background: '#1877f2', color: 'rgb(236, 213, 7)' }}>
								Facebook
							</button>
						</a>
					</div>
				</div>
			</section>
			<br />
			<br />
			<br />
			<Footer />
		</div>
	);
};

export default DigitalServices;
